<template>
  <el-alert
    type="info"
    v-if="isCampaignTemplate"
    :title="$t('Campaign_VoucherCodesSetup_Template_Alert')"
    :closable="false"
    :show-icon="true"
  />
  <el-row v-else>
    <el-col :span="12" class="flexbox">
      <form-item
        :label="$t('Campaign_VoucherCodesSetup_UploadFile')"
        class="voucher-codes-upload"
      >
        <el-upload
          action="#"
          accept=".csv"
          :http-request="handleUpload"
          :show-file-list="false"
        >
          <div class="label">
            <i class="el-icon-upload2" />
            <span v-if="fileName">{{ fileName }}</span>
            <span v-else>{{
              $t('Campaign_VoucherCodesSetup_Button_Upload')
            }}</span>
          </div>
        </el-upload>
      </form-item>
    </el-col>
  </el-row>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import FormItem from '@/common/components/form/FormItem'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'VoucherCodesSetup',

  components: { FormItem },

  props: {
    value: {
      required: true
    }
  },

  data() {
    return {
      fileName: null
    }
  },

  mounted() {
    if (this.value.voucher_codes_file) {
      this.fileName = this.value.voucher_codes_file.name || null
    }
  },

  computed: {
    isCampaignTemplate() {
      return (
        this.value.is_campaign_template ||
        ($hasFeature('campaignTemplates') &&
          (this.$route.name === 'CreateTemplateCampaign' ||
            this.$route.name === 'UpdateTemplateCampaign' ||
            this.$route.name === 'CopyTemplateCampaign' ||
            this.$route.name === 'ViewTemplateCampaign'))
      )
    }
  },

  methods: {
    handleUpload(option) {
      const formData = new FormData()
      formData.append('voucher_codes_file', option.file)
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `campaigns/upload-voucher-codes`,
          config: { headers: { 'Content-Type': 'multipart/form-data' } },
          data: formData
        })
      )
        .then(({ data }) => {
          this.value.voucher_codes_file = {
            name: option.file.name,
            file: data.file,
            rows: data.rows
          }
          this.fileName = option.file.name
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped>
>>> .el-upload {
  width: 100%;
  border: 1px dashed #dbdee7;
  border-radius: 4px;
  color: #a6a6a6;
  font-size: 14px;
  position: relative;
  overflow: hidden;
  height: 38px;
}

>>> .el-upload:hover {
  background-color: #e6f3fb;
  border: 1px dashed #1d87c8;
  color: #1d87c8;
}

.label {
  padding-left: 40px;
  padding-right: 40px;
  line-height: 38px;
  white-space: nowrap;
}

.label i {
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/VoucherCodesSetup.vue